class @Network
  constructor: ->
    $('input#network_slider_disabled, input#network_slider_enabled').on 'change', (e) ->
      $(this).closest('form').siblings('#slider-content').slideToggle 'fast'
      $(this).closest('.btn-group').children('.btn').toggleClass('btn-secondary btn-primary').removeClass('active')
      $('a[data-target="#modal-slider-content-new"]').toggle()
      $(this).closest('form').submit()

window.Network = @Network;
